<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FundAuditUserFilePreviewModal',
})
</script>
<template>
  <Modal v-model:visible="visible" centered destroy-on-close title="资金监审名单预览" width="1000px" v-bind="$attrs">
    <FilePreview :id="id" :pId="pId" />
  </Modal>
</template>

<script lang="ts" setup name="FundAuditUserFilePreviewModal">
import { Modal } from 'ant-design-vue'
import { ref } from 'vue'
import FilePreview from './index.vue'
const visible = ref(false)
const id = ref<string>()
const pId = ref<string>()
const open = (fileId: string, projectId: string) => {
  id.value = fileId
  pId.value = projectId
  visible.value = true
}
const close = () => {
  visible.value = false
  id.value = undefined
}
defineExpose({
  open,
  close
})
</script>
